import { useCallback, useEffect, useState } from 'react';
import { getRecentSearches, addRecentSearch } from '../storage/RecentSearchesService';

type Argument = {
	isNLSSearchOn: boolean;
};

export function useRecentSearches({ isNLSSearchOn }: Argument) {
	const [recentSearchTerms, setRecentSearchTerms] = useState<string[]>([]);

	useEffect(() => {
		const initializeRecentSearches = async () => {
			const terms = await getRecentSearches(isNLSSearchOn);
			setRecentSearchTerms(terms);
		};

		initializeRecentSearches();
	}, [isNLSSearchOn]);

	const addSearchTermToRecentSearches = useCallback(
		async (term: string) => {
			const updatedTerms = await addRecentSearch(isNLSSearchOn, term);
			setRecentSearchTerms(updatedTerms);
		},
		[isNLSSearchOn],
	);

	return { addSearchTermToRecentSearches, recentSearchTerms };
}
